function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FullWidthSpan from "../../../styled/FullWidthSpan";

class ToggleActionEmptyTrigger extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(FullWidthSpan, {
        className: this.props.required ? 'text-danger' : 'text-info'
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faPlus
      }));
    });
  }

}

export default ToggleActionEmptyTrigger;